(function($) {
  $(document).ready(function() {
    /**
     * COLLAPSES
     *
     * Helps with styling `.panel-collapse` elements.
     */

    // Add a class '.in' on opened '.panel' when they are a Boostrap collapse element.
    $('.panel-collapse').on('show.bs.collapse', function (event) {
      event.stopPropagation();

      $(this).closest('.panel').addClass('in');
    });

    // Remove the '.in' class from the '.panel' element when collapse is closed
    $('.panel-collapse').on('hidden.bs.collapse', function (event) {
      event.stopPropagation();

      $(this).closest('.panel').removeClass('in');
    });
  });
})(jQuery);
